export const seoKeywords = {
  name: 'keywords',
  content:
    'XRPL development, Ripple development, hire XRPL developer, XRPL blockchain development company, blockchain development, XRP ledger  development, enterprise blockchain development, defi on ripple development, enterprise XRPL development services',
};

export const xrplBlockchainDevelopmentSeo = {
  title: 'XRPL Development Services with Rumble Fish',
  meta: [
    seoKeywords,
    {
      name: 'description',
      content:
        'XRPL blockchain development with Rumble Fish. We build fast, compliant, and cost-effective blockchain solutions on the XRP Ledger - from payment systems and tokenization platforms to enterprise DeFi applications. Full-stack XRPL development that actually ships.',
    },
  ],
};
